import React from "react";
import { Link } from "react-router-dom";
import "../styles/PoliticalMatchIntro.css";
import demoBanner from "../assets/demo-banner.png";

export default function PoliticalMatchIntro() {
  const scrollToHowItWorks = (e) => {
    e.preventDefault();
    const howItWorksSection = document.getElementById("how-it-works");
    howItWorksSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <h1>
            Find Your <span>Political Match</span> in Parliament
          </h1>
          <p>
            Discover which MPs truly align with your values and priorities.
            Factaroo uses real voting records and speeches to match you with
            representatives who share your views on issues that matter to you.
          </p>
          <div className="hero-buttons">
            <Link to="/policy-areas" className="btn btn-primary">
              Start Matching
            </Link>
            <a
              href="#how-it-works"
              className="btn btn-info"
              onClick={scrollToHowItWorks}
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      <section id="how-it-works" className="how-it-works">
        <div className="section-container">
          <div className="section-title">
            <h2>How It Works</h2>
          </div>

          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-icon">
                <div>
                  <i className="icon-select"></i>
                </div>
              </div>
              <div className="step-content">
                <h3>Select Policy Areas</h3>
                <p>
                  Choose the political issues that matter most to you, from
                  climate change to the economy.
                </p>
              </div>
            </div>

            <div className="step-arrow">→</div>

            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-icon">
                <div>
                  <i className="icon-swipe"></i>
                </div>
              </div>
              <div className="step-content">
                <h3>Swipe on Policies</h3>
                <p>
                  Swipe right to support, left to oppose, up to mark as a
                  priority issue.
                </p>
              </div>
            </div>

            <div className="step-arrow">→</div>

            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-icon">
                <div>
                  <i className="icon-match"></i>
                </div>
              </div>
              <div className="step-content">
                <h3>Discover Your Matches</h3>
                <p>
                  See which MPs most closely align with your views, based on
                  their actual voting records.
                </p>
              </div>
            </div>
          </div>

          <div className="get-started-btn">
            <Link to="/policy-areas" className="btn btn-primary">
              Get Started Now
            </Link>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <div className="section-container">
          <div className="demo-content">
            <div className="demo-text">
              <h2>Fun Interface, Serious Data</h2>
              <p>
                Factaroo combines the engaging swipe mechanics of dating apps
                with rigorous analysis of parliamentary voting records and
                speeches.
              </p>
              <ul className="demo-features">
                <li>
                  <span>✓</span> Real voting data from Parliament
                </li>
                <li>
                  <span>✓</span> Analysis of MP speeches and positions
                </li>
                <li>
                  <span>✓</span> Clear, easy-to-understand policy statements
                </li>
                <li>
                  <span>✓</span> Personalized match results
                </li>
              </ul>
              <div className="demo-cta">
                <Link to="/policy-areas" className="btn btn-primary">
                  Try It Now
                </Link>
              </div>
            </div>

            <div className="demo-card">
              <div className="policy-card">
                <div className="policy-img">
                  <img
                    src={demoBanner}
                    alt="Demo policy banner"
                    className="policy-banner"
                  />
                </div>
                <div className="policy-content">
                  <div className="policy-category">Environment</div>
                  <h3 className="policy-title">Climate Action</h3>
                  <p className="policy-desc">
                    Support ambitious emission reduction targets and increased
                    renewable energy investment.
                  </p>
                  <div className="swipe-actions">
                    <button className="demo-swipe-btn dislike" disabled>
                      ✕
                    </button>
                    <button className="demo-swipe-btn priority" disabled>
                      ★
                    </button>
                    <button className="demo-swipe-btn like" disabled>
                      ✓
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="section-container">
          <div className="section-title">
            <h2>Why Factaroo?</h2>
          </div>
          <div className="about-cards">
            <div className="about-card">
              <div className="about-icon">
                <i className="icon-transparent"></i>
              </div>
              <h3>Transparent</h3>
              <p>
                All matches are based on real parliamentary data, not opinions
                or media portrayals.
              </p>
            </div>
            <div className="about-card">
              <div className="about-icon">
                <i className="icon-unbiased"></i>
              </div>
              <h3>Unbiased</h3>
              <p>
                Our algorithm doesn't favor any political party or ideology.
              </p>
            </div>
            <div className="about-card">
              <div className="about-icon">
                <i className="icon-educational"></i>
              </div>
              <h3>Educational</h3>
              <p>
                Learn about policy issues while discovering your political
                matches.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
